import React from "react";

import { Layout } from "../components/ui";

interface EmptyPageProps {
  children: React.ReactNode;
}

const EmptyPage: React.FC<EmptyPageProps> = ({ children }) => {
  return (
    <>
      <Layout.Main>{children}</Layout.Main>

      <Layout.Aside />
    </>
  );
};

export default EmptyPage;
